export const isProduction = !(
  global.location.hostname === 'localhost' || global.location.hostname === '127.0.0.1'
)

export const FUNCTIONS_BASE_URL = isProduction
  ? 'https://us-central1-coachee-ef3ee.cloudfunctions.net'
  : 'http://127.0.0.1:5001/coachee-ef3ee/us-central1'

export const API_BASE_URL = `${FUNCTIONS_BASE_URL}/api`
